import { render, staticRenderFns } from "./droptip.vue?vue&type=template&id=0af452d5&"
import script from "./droptip.vue?vue&type=script&lang=js&"
export * from "./droptip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports